import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { ApiError, apiGet } from "./api";
import type { CountryConfig } from "./country";

export interface AccountantCategory {
  id: string;
  name: string;
}

export interface AccountantStats {
  total_users: number;
  active_subscribers: number;
  pending_invites: number;
  commissions_earned: number;
  commissions_earning: number;
}

export interface AccountantProfile {
  id: string;
  email: string;
  name: string;
  business_name: string;
  phone: string;
  support_phone: string | null;
  categories: AccountantCategory[];
  stats: AccountantStats;
  /** The accountant's own market. Fallback for clients who have not accepted
   *  their invite yet, so the portal never has to assume Australia. */
  country?: string;
  country_config?: CountryConfig;
}

export function useAccountant() {
  const navigate = useNavigate();

  const query = useQuery({
    queryKey: ["accountant-me"],
    queryFn: () => apiGet<AccountantProfile>("/api/accountant/me"),
    retry: false,
  });

  useEffect(() => {
    if (query.error instanceof ApiError && query.error.status === 401) {
      navigate("/login", { replace: true });
    }
  }, [query.error, navigate]);

  return query;
}
